export const environment = {
  production: true,
  buildId: '2836317939519431',
  configFile: 'config.json',
};
